<template>
    <div class="marginCon">
        <Card>
            <!-- 搜索 -->
            <div v-if="offModel">

                <div class="top" v-if='roleType==1'>
                    <Button type="success" class="addButton"  @click="addData(1)" style="margin-right:8px;">{{$t("firmwareVersion.addButton")}}</Button>
                </div>
                <Table style="width: 100%;margin-top: 30px;" :columns="titleName" :data="tableList.tableData"  ref="selection" @on-sort-change="sortCustom" :loading='loading'></Table>
                <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :page-size-opts="[10,15,20]" placement="top" class="pages"/>
            </div>

             <!-- 编辑 / 添加  模态框组件 -->
             <ModelBox :showModel.sync="addBox.showModel" :offModel.sync='offModel' :fn="addBox.callbackFn" :type="1" :editFormData="addBox.editFormData"></ModelBox>

              <!-- 删除弹框组件 -->
             <DeleteDialog ref="deleteChild" @ievent = "ievent"  :title='$t("orderManage.deletModel.changeTitle")' :cont='$t("orderManage.deletModel.changeCont")'></DeleteDialog>
        </Card>
    </div>
</template>

<script>

import common from '@/common/common.js';
import moment from 'moment';
import ModelBox from './component/verAddModel';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件
import { mapState } from 'vuex'

    export default {
        name: "firmwareVersion",
        components: {
            ModelBox,
            DeleteDialog,
        },
        data(){
            return{
                loading: true,
                offModel: true,
                addBox:{//规格弹框组-新增
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                page:{//分页排序
                    total:0,//总条数
                    pageSize:15,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                tableList:{
                    tableData:[],
                    hasSelectData:{}
                },
                
               
            }
        },
        computed:{
           ...mapState(['local','selectId']),
            roleType(){
	        	 let res = '2'
	        	 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	        		 res = this.$store.state.uInfo.roleType
	        	 }
	        	 return res
	         },
           titleName(){
               return [
                    {
                        title:this.$t('firmwareVersion.titleName.id'),
                        'title-zh-CN':'固件编号',
                        'title-en-US':'Firmware id',
                        key: 'id',
                        width: 140,
                        sortable: true,
                        align:'center',
                        tree: true
                    },
                    {
                        title:this.$t('firmwareVersion.titleName.fwareVersion'),
                        'title-zh-CN':'固件版本',
                        'title-en-US':'Version',
                        key: 'fwareVersion',
                        minWidth: 240
                    },
                    {
                        title:this.$t('firmwareVersion.titleName.hardwareVersion'),
                        'title-zh-CN':'硬件版本',
                        'title-en-US':'Version',
                        key: 'hardware',
                        width: 160
                    },
                    {
                        title:this.$t('firmwareVersion.titleName.fileName'),
                        'title-zh-CN':'文件名',
                        'title-en-US':'File name',
                        key: 'fileName',
                        minWidth: 220
                    },
                    {
                        title:this.$t('firmwareVersion.titleName.suitDeviceType'),
                        'title-zh-CN':'设备型号',
                        'title-en-US':'Device type',
                        key: 'suitDeviceType',
                        minWidth: 130
                    },
                    {
                        title:this.$t('firmwareVersion.titleName.updateInformation'),
                        'title-zh-CN':'更新信息',
                        'title-en-US':'Update message',
                        key: 'updateInformation',
                        minWidth: 180,
                        render:(h, params)=>{
                            let flag = params.row.updateInformation;
                            let flag1 = flag.slice(2,flag.length-2);
                            let arr = flag1.split('&&')
                            let stext = ''
                            arr.map((item,index)=>{
                                let indexflag = item.indexOf('&')
                                if((this.local=='zh-CN' && item.slice(0,indexflag)=='zh') || (this.local=='en-US' && item.slice(0,indexflag)=='en')){
                                    stext = (item.split('&'))[1]
                                }
                               
                            })
                          
                            return h('div',{
                                attrs:{
                                    title:stext
                                }
                            },stext || '')
                        }
                    },
                    {
                        title:this.$t('firmwareVersion.titleName.releaseTime'),
                        'title-zh-CN':'发布日期',
                        'title-en-US':'Release date',
                        key: 'releaseTime',
                        width: 180,
                        render:(h, params)=>{
                            let stext = moment(params.row.releaseTime*1).format('YYYY-MM-DD HH:mm:ss')
                             return h('div',stext || '')
                        }
                    },
                   
                    {
                        title:this.$t('firmwareVersion.titleName.uploadTime'),
                        'title-zh-CN':'上传日期',
                        'title-en-US':'Upload date',
                        key: 'uploadTime',
                        width: 180,
                        render:(h, params)=>{
                            let stext = moment(params.row.uploadTime*1).format('YYYY-MM-DD HH:mm:ss')
                             return h('div',stext || '')
                        }
                    }
                ]
           },
            Operation(){
                return {
		            	title: this.$t('productPage.titleName.Operation'),
                        'title-zh-CN':'操作',
                        'title-en-US':'Operation',
                        // fixed:'right',
		            	width:120,
                        key: "Operation",
		            	render: (h, params) => {
                            let that = this
                            return h('div',{
                                style:{
                                    display:'flex',
                                    'justify-content':'center'
                                }
                            },[
                                h('Button',{
		            	              props: {
                                          type: "error",
                                          size: 'small'
                                      },
                                      style:{
                                      },
		            	              on: {
		            	                  click: () => { 
                                              this.todelData(params.row)
                                           }
		            	              }
		            	          },that.$t("delete"))
                            ])
		            	}
		        }
            },
        },
        created (){
            if(this.roleType==1){
               this.titleName.push(this.Operation)
            }
            this.getData()
        },
  
        methods: {
            addData(type) {  //添加或编辑数据
                this.addBox.showModel = true
                this.offModel = false
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = this.tableList.hasSelectData
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    // this.clearbtnStatus()
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
            todelData(item) {// 删除
                if(this.roleType==2) return
                this.tableList.hasSelectData = item
                this.$refs.deleteChild.showit();
            },
            ievent() {// 删除
                if(this.roleType==2) return
 
                this.axios.post(this.config.urlArray.fwaresDel, {id:this.tableList.hasSelectData.id}).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    // common.msg('error','删除失败')
                })
            },
            searchItem(){

            },
            getData(){ //获取数据
                let getData = {
                    params:{
                        page:this.page.current,
                        limit:this.page.pageSize,
                        sort:this.page.key,
                        asc:this.page.order,
                        dealerId:this.selectId
                    }
                }

                this.axios.post(this.config.urlArray.fwaresList,getData.params).then((result) => {

                    common.ajaxMsg(result.data,false,()=>{

                        let resData = result.data.data
                        //处理数组
                        if(resData){
                            this.tableList.tableData = resData  //渲染数据
                            this.page.total = result.data.data.length
                            this.loading = false
                        }
                    });
                }).catch((err) => {
                    // common.msg('error','获取失败',()=>{})
                });
            },
            sortCustom (data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changePage (nowpage) {//切换分页
                this.page.current = nowpage
                this.getData()
            },
            changeSize (nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            }
        }
    }
</script>



